import { render, staticRenderFns } from "./dialogos.vue?vue&type=template&id=f669efe4&scoped=true&"
import script from "./dialogos.vue?vue&type=script&lang=js&"
export * from "./dialogos.vue?vue&type=script&lang=js&"
import style0 from "./dialogos.vue?vue&type=style&index=0&id=f669efe4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f669efe4",
  null
  
)

export default component.exports